<template>
  <div class="cart-modal-content" v-if="cartOring">
    <div class="cart-model">
      <div class="model-text">
        <dl>
          <dt>名称：</dt>
          <dd>{{ cartOring.name ? cartOring.name : "O形圈" }}</dd>
        </dl>
        <dl>
          <dt>型号：</dt>
          <dd>
            {{ cartOring.innerDiameter }}X{{ cartOring.wireDiameter }} {{ cartOring.material }}
            {{ cartOring.hardness }}
          </dd>
        </dl>
        <dl>
          <dt>要求：</dt>
          <dd class="park">
            每包
            <input type="number" v-model="cartValue.perPackageNums" />个
          </dd>
        </dl>
      </div>
      <div class="model-stepper">
        <van-stepper v-model="cartValue.nums" integer min="1" />
      </div>
    </div>
    <div class="cart-price">
      <div class="price-text">
        <dl>
          <dt>单价：</dt>
          <dd>
            <small>¥</small>
            {{ (cartOring.unitPrice + packingCharges).toFixed(2) }}
            <small>(不含税)</small>
          </dd>
        </dl>
        <dl>
          <dt>小计：</dt>
          <dd>
            <b class="sum">
              <small>¥</small>
              {{ showPrice }}
            </b>
            <del>
              <small>¥</small>
              {{ originalPrice }}
            </del>
            <small>(不含税)</small>
            <span class="sum-tips" @click="showPriceTips()" v-if="tipsInfo && tipsInfo.show">
              <svg
                width="13"
                height="13"
                viewBox="0 0 13 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6.02539 12.7461C9.29492 12.7461 12.002 10.0391 12.002 6.76953C12.002 3.50586 9.28906 0.792969 6.01953 0.792969C2.75586 0.792969 0.0488281 3.50586 0.0488281 6.76953C0.0488281 10.0391 2.76172 12.7461 6.02539 12.7461ZM5.91406 8.04102C5.59766 8.04102 5.42188 7.87695 5.42188 7.56055V7.47852C5.42188 6.875 5.75 6.54688 6.18945 6.24219C6.73438 5.87305 6.99219 5.66211 6.99219 5.24023C6.99219 4.77734 6.62891 4.46094 6.06641 4.46094C5.65625 4.46094 5.3457 4.66602 5.1582 5C4.95898 5.23438 4.90625 5.41602 4.55469 5.41602C4.34961 5.41602 4.13281 5.26953 4.13281 4.99414C4.13281 4.88867 4.15039 4.78906 4.17969 4.68945C4.33789 4.12109 5.04688 3.62891 6.10156 3.62891C7.15039 3.62891 8.05859 4.17383 8.05859 5.19336C8.05859 5.93164 7.63086 6.2832 7.03906 6.6875C6.61133 6.97461 6.40625 7.18555 6.40625 7.53125V7.60742C6.40625 7.84766 6.22461 8.04102 5.91406 8.04102ZM5.93164 9.80469C5.59766 9.80469 5.27539 9.53516 5.27539 9.17188C5.27539 8.80859 5.5918 8.53906 5.93164 8.53906C6.27734 8.53906 6.59375 8.80273 6.59375 9.17188C6.59375 9.54102 6.27148 9.80469 5.93164 9.80469Z"
                  fill="#CCCCCC"
                />
              </svg>
              查看价格规则
            </span>
          </dd>
        </dl>
      </div>
    </div>
    <div class="modal-footer">
      <van-row gutter="0" v-if="type === 'edit'">
        <van-col span="24">
          <van-button
            type="primary"
            :loading="updateCartBtn"
            loading-text="更新中..."
            @click="updateCart"
            block
            >确定</van-button
          >
        </van-col>
      </van-row>
      <van-row gutter="0" v-else>
        <van-col span="12">
          <van-button type="default" @click="addCart" block>加入进货单</van-button>
        </van-col>
        <van-col span="12">
          <van-button type="primary" @click="toOrder" block>立即订购</van-button>
        </van-col>
      </van-row>
    </div>
    <van-dialog v-model="PriceTipsDialog" class="price-tips-dialog">
      <div class="price-tips-content">
        <div v-html="tipsInfo.html" v-if="tipsInfo && tipsInfo.html"></div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import api from "@/components/axios";

export default {
  name: "cart",
  props: {
    cartOring: Object,
    cartValue: Object,
    type: String,
    editIndex: Number,
  },
  data() {
    return {
      showTips: false,
      price: 0,
      PriceTipsDialog: false,
      updateCartBtn: false,
      parkType: 1,
      tipsInfo: null,
    };
  },
  computed: {
    cartList() {
      return this.$store.state.cartList;
    },
    oringModalShow: {
      get() {
        return this.$store.state.oringModalShow;
      },
      set(value) {
        this.$store.commit("storeOringModal", value);
      },
    },
    CartModalShow: {
      get() {
        return this.$store.state.CartModalShow;
      },
      set(value) {
        this.$store.commit("storeCartModal", value);
      },
    },
    packingCharges() {
      // 包装费：产品内径、每包数量
      const { innerDiameter } = this.cartOring;
      const { perPackageNums } = this.cartValue;
      if (innerDiameter <= 150) {
        if (perPackageNums < 10) {
          return 0.8;
        } else if (perPackageNums < 100) {
          return 0.19;
        } else {
          return 0.07;
        }
      } else if (innerDiameter <= 300) {
        if (perPackageNums < 10) {
          return 1.15;
        } else if (perPackageNums < 100) {
          return 0.19;
        } else {
          return 0.07;
        }
      } else if (innerDiameter > 300) {
        if (perPackageNums < 10) {
          return 1.15;
        } else if (perPackageNums < 100) {
          return 0.28;
        } else {
          return 0.08;
        }
      }
      return 0;
    },
    discount() {
      const { nums } = this.cartValue;
      let discount = 1;
      if (nums >= 100 && nums < 500) {
        discount = 0.75;
      } else if (nums >= 500) {
        discount = 0.55;
      }
      return discount;
    },
    totalPrice() {
      // 计算价格：［sum（（单价+包装费）*数量*折扣）］+运费
      if (this.cartOring) {
        const { unitPrice } = this.cartOring;
        const { nums } = this.cartValue;
        const price = (unitPrice + this.packingCharges) * nums * this.discount;
        return price.toFixed(2);
      }
      return 0;
    },
    originalPrice() {
      if (this.cartOring) {
        const { unitPrice } = this.cartOring;
        const { nums } = this.cartValue;
        const price = (unitPrice + this.packingCharges) * nums;
        return price.toFixed(2);
      }
      return 0;
    },
    showPrice() {
      return (this.totalPrice * this.discountValue).toFixed(2);
    },
    perPackageNums() {
      return this.cartValue.perPackageNums;
    },
    nums() {
      return this.cartValue.nums;
    },
  },
  watch: {},
  created() {
    this.getSetting();
  },
  methods: {
    addCart() {
      if (this.cartValue.perPackageNums < 1) {
        this.$toast("每包数量不小于1");
        return false;
      }
      let data = {
        nums: this.cartValue.nums,
        perPackageNums: this.cartValue.perPackageNums,
        productType: "ORING",
        totalPrice: this.totalPrice,
        product: {
          id: this.cartOring.id,
        },
      };
      api.post("/order_record/cart", data).then((res) => {
        console.log(res);
        if (res.data.code === 200) {
          this.$store.dispatch("getCartList");
          this.$toast.success("已添加成功，请在购物车中下单");
          this.$store.commit("storeOringModal", false);
        }
      });
    },
    calculate(number) {
      if (this.cartOring) {
        api
          .post("/order_record/calculate_price", {
            nums: number ? number : this.cartValue.nums,
            perPackageNums: this.cartValue.perPackageNums,
            productType: "ORING",
            totalPrice: this.totalPrice,
            product: {
              id: this.cartOring.id,
            },
          })
          .then((res) => {
            console.log(res);
            if (res.data.code === 200) {
              this.price = res.data.data;
            }
          });
      }
    },
    updateCart() {
      // 更新购物车
      if (this.cartValue.perPackageNums < 1) {
        this.$toast("每包数量不小于1");
        return false;
      }
      this.updateCartBtn = true;
      this.calculate();
      let cartList = JSON.parse(JSON.stringify(this.cartList));
      // const perPackageNums = parseInt(this.cartValue.perPackageNums);

      cartList[this.editIndex].nums = this.cartValue.nums;
      cartList[this.editIndex].perPackageNums = this.cartValue.perPackageNums;

      api
        .put("/order_record/cart", cartList)
        .then((res) => {
          console.log(res);
          this.$store.dispatch("getCartList");
          this.$store.commit("storeCartModal", false);
          this.updateCartBtn = false;
        })
        .catch((err) => {
          console.log(err);
          this.updateCartBtn = false;
        });
    },
    toOrder() {
      if (this.cartValue.perPackageNums < 1) {
        this.$toast("每包数量不小于1");
        return false;
      }
      this.calculate();
      const data = [
        {
          nums: this.cartValue.nums,
          perPackageNums: this.cartValue.perPackageNums,
          productType: "ORING",
          totalPrice: this.price > 0 ? this.price : this.totalPrice,
          product: {
            id: this.cartOring.id,
          },
        },
      ];
      api.post("/order_record", data).then((res) => {
        if (res.data.code === 200) {
          this.$toast("订单已记录，优惠活动线下进行");
          this.$store.commit("storeOringModal", false);
          this.$router.push({
            path: "/cart-result",
            query: {
              id: res.data.data,
            },
          });
        }
      });
    },
    storeModalState() {
      if (this.type === "edit") {
        this.$store.commit("storeCartModal", false);
      } else {
        this.$store.commit("storeOringModal", false);
      }
    },
    showPriceTips() {
      this.PriceTipsDialog = true;
    },
    getSetting() {
      api.get("/setting?type=POPUP").then((res) => {
        if (res.data.code === 200) {
          this.tipsInfo = res.data.data[1].content;
        }
      });
    },
  },
};
</script>
